import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
  Badge,
  ButtonGroup,
  Button
} from 'reactstrap';

const CustomerEvents = ({ pb, customerId }) => {
  const [events, setEvents] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  const fetchEvents = async () => {
    try {
      const response = await pb.collection('events').getList(1, 50, {
        filter: `customer_id.id?="${customerId}"`,
        sort: '-created',
      });
      setEvents(response.items);
    } catch (error) {
      console.error('Error fetching events:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [customerId]);

  const getEventBadgeColor = (eventType) => {
    const typeColors = {
      'Rapor': 'info',
      'Bakım': 'success',
      'Onarım': 'warning',
      'Teklif': 'primary',
      'Hatırlatma': 'secondary',
      'Proje Başlangıcı': 'danger',
      'Proje Bitişi': 'danger',
      'Fatura': 'dark',
      'Tedarikçi': 'primary',
      'Teknik Servis': 'warning'
    };
    return typeColors[eventType[0]] || 'primary';
  };

  const filteredEvents = events.filter(event => {
    if (filter === 'all') return true;
    if (filter === 'active') {
      return new Date(event.end_date) >= new Date();
    }
    if (filter === 'completed') {
      return new Date(event.end_date) < new Date();
    }
    return true;
  });

  if (loading) {
    return <div className="text-center p-3">Loading...</div>;
  }

  return (
    <Card>
      <CardHeader className="d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Müşteri Etkinlikleri</h5>
        <ButtonGroup size="sm">
          <Button
            color={filter === 'all' ? 'primary' : 'light'}
            onClick={() => setFilter('all')}
          >
            Tümü
          </Button>
          <Button
            color={filter === 'active' ? 'primary' : 'light'}
            onClick={() => setFilter('active')}
          >
            Aktif
          </Button>
          <Button
            color={filter === 'completed' ? 'primary' : 'light'}
            onClick={() => setFilter('completed')}
          >
            Tamamlanan
          </Button>
        </ButtonGroup>
      </CardHeader>
      <CardBody>
        <div className="timeline-2">
          {filteredEvents.map((event) => (
            <div key={event.id} className="timeline-item">
              <div className="d-flex">
                <div className="flex-shrink-0">
                  <div className={`avatar-sm text-bg-${getEventBadgeColor(event.event_type)} rounded`}>
                    <span className="avatar-title">
                      {new Date(event.start_date).getDate()}
                    </span>
                  </div>
                </div>
                <div className="flex-grow-1 ms-3">
                  <h6 className="mb-1">{event.title}</h6>
                  <div className="d-flex align-items-center gap-2">
                    <Badge 
                      color={getEventBadgeColor(event.event_type)} 
                      className="text-uppercase"
                    >
                      {event.event_type[0]}
                    </Badge>
                    <small className="text-muted">
                      {new Date(event.start_date).toLocaleDateString()} - {new Date(event.end_date).toLocaleDateString()}
                    </small>
                    <Badge 
                      color="secondary"
                      className="text-uppercase ms-2"
                    >
                      {event.status}
                    </Badge>
                  </div>
                  {event.description && (
                    <p className="text-muted mt-2 mb-0">{event.description}</p>
                  )}
                  {event.location && (
                    <small className="text-muted d-block mt-2">
                      <i className="ri-map-pin-line me-1"></i>
                      {event.location}
                    </small>
                  )}
                </div>
              </div>
            </div>
          ))}
          {filteredEvents.length === 0 && (
            <div className="text-center text-muted py-4">
              <p className="mb-0">Etkinlik bulunamadı</p>
            </div>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

CustomerEvents.propTypes = {
  pb: PropTypes.object.isRequired,
  customerId: PropTypes.string.isRequired
};

export default CustomerEvents;